import React from 'react';

import CommonImage from '@/components/CommonImage';
import { TASK_CONFIGURATIONS_TABLE_HEADERS } from '@/features/task-configuration/constants';
import { useTaskConfigurations } from '@/store/reducers';
import { isAdmin, replaceUnderLine } from '@/utils/Util';

const TaskConfigurationTable = ({ onEditTask }) => {
	const { stageList = [] } = useTaskConfigurations();

	return (
		<>
			{stageList?.length > 0 ? (
				<div className="task-configuration-table mt-3">
					<table className="table with-border height-sm hover">
						<thead>
							<tr>
								{TASK_CONFIGURATIONS_TABLE_HEADERS.map((head) => (
									<th className="white-space-nowrap regular-12 weight-500" key={head.id}>
										{head.label} {head?.id === 'stage' ? `(${stageList?.length})` : ''}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{stageList?.map((stage) =>
								stage.taskResponse.map((task, taskIndex) => (
									<tr
										key={task.id}
										className={`${task?.status === 'DISABLED' ? 'disable-column' : ''}`}
									>
										{taskIndex === 0 && (
											<td
												className="stage-column"
												rowSpan={stage?.taskResponse?.length}
											>
												{stage?.stageName}
											</td>
										)}
										<td className="sl-column">{taskIndex + 1}</td>
										<td className="task-column">
											<p>{task?.name}</p>
										</td>
										<td className="task-column">
											{task?.journeyMappingTypeMap?.map((j, idx) => {
												const journeyName =
													j?.journey?.name ||
													j?.journeyMappingType?.name ||
													j?.name ||
													'-';
												const key =
													j?.journeyMappingType?.constant ||
													j?.journey?.id ||
													j?.journey?.name ||
													j?.name ||
													idx;

												return (
													<p key={key}>
														{j?.journeyMappingType?.name?.slice(0, 1)}:{' '}
														{journeyName}
													</p>
												);
											})}
										</td>
										<td className="condition-column">
											<p>{replaceUnderLine(task?.taskValueType?.name) || '-'}</p>
										</td>
										<td className="dependency-column">
											<p>
												{task?.dependentTaskList
													?.map((dependency) => dependency?.name)
													.join(',') || '-'}
											</p>
										</td>
										<td className="complete-column">
											<p>
												{task?.userTypeResponseList
													?.map((user) => user.name)
													.join(', ') || '-'}
											</p>
										</td>

										<td className="not-required-column">
											<p>
												{task?.taskNotRequiredConditionList?.length
													? replaceUnderLine(
															task?.taskNotRequiredConditionList.join(', ') ||
																''
														)
													: '-'}
											</p>
										</td>
										<td className="action-column">
											{isAdmin() && (
												<div className="option">
													<div className="dropdown">
														<button
															aria-expanded="false"
															className="btn btn-default dropdown-toggle"
															data-toggle="dropdown"
															id="menu1"
															type="button"
														>
															<CommonImage
																src="/icons/more_icon.svg"
																alt="more_icon"
															/>
														</button>
														<ul
															aria-labelledby="menu1"
															className="dropdown-menu dropdown-menu-right shadow-lg"
															role="menu"
														>
															<li
																className="px-4 pb-3 pt-3"
																role="presentation"
																onClick={() => onEditTask?.({ task, stage })}
															>
																<span className="font-weight-normal text-black">
																	Edit
																</span>
															</li>
														</ul>
													</div>
												</div>
											)}
										</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			) : (
				<div className="no-favorite not-found-table">
					<div className="w-100">
						<div className="alert alert-secondary text-center" role="alert">
							No Data Found
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default TaskConfigurationTable;
